import { enableProdMode, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment.dev';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

// Desactivar todos los console.log en la aplicación
console.log = () => {};

if (environment.production) {
  enableProdMode();
}

// Prevent automatic push/notification permission prompts from any third-party code.
try {
  if (typeof window !== 'undefined') {
    if ('Notification' in window && (Notification as any).requestPermission) {
      (Notification as any).requestPermission = () => Promise.resolve('denied');
    }

    if ((window as any).PushManager && (window as any).PushManager.prototype) {
      (window as any).PushManager.prototype.subscribe = function () {
        return Promise.reject(new Error('Push disabled by app configuration'));
      };
    }
  }
} catch (e) {
  // Silent catch
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule), 
    provideAnimations(),  
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    })
  ],
}).catch((err) => {});
